<template>
    <div class="home">
        <HandMenu></HandMenu>
        <el-card shadow="never"  style="border: 0;border-right: 1px solid #EBEEF5;" >
            <el-row>
                <el-col :md="3">
                    <h1>
                        <!-- 为了能够占空间 -->
                    </h1>
                </el-col>
                <el-col :md="21">
                    <h2 style="margin-bottom: 0;">Welcome ! 来自{{city}}的朋友！</h2>
                    <h4 style="font-weight: 500;margin-top: 5px;margin-left: 15px;">加油吧！你还不能输！</h4>
                </el-col>
            </el-row>
            <!--            <el-row :gutter="20" style="text-align: center;">-->
            <!--                <el-col :md="3">-->
            <!--                    <h1>-->
            <!--                        &lt;!&ndash; 为了能够占空间 &ndash;&gt;-->
            <!--                    </h1>-->
            <!--                </el-col>-->
            <!--                <el-col :md="6" style="margin-top:15px ;">-->
            <!--                    <el-card shadow="hover" class="showText-blue">-->
            <!--                        <p style="color:rgb(0, 77, 235);font-size: 18px;">访问总数</p>-->
            <!--                        <p style="font-weight: 700;">15</p>-->
            <!--                        &lt;!&ndash; svg图 &ndash;&gt;-->
            <!--                        <svg class="peity" height="50" width="100">-->
            <!--                            <rect data-value="2" fill="rgb(0, 77, 235)" x="1" y="38.888888888888886" width="8"-->
            <!--                                  height="11.111111111111114"/>-->
            <!--                            <rect data-value="5" fill="rgba(0, 77, 235, 0.3)" x="11.000000000000002"-->
            <!--                                  y="22.22222222222222"-->
            <!--                                  width="7.999999999999998"-->
            <!--                                  height="27.77777777777778"/>-->
            <!--                            <rect data-value="9" fill="rgb(0, 77, 235)" x="21" y="0" width="8" height="50"/>-->
            <!--                            <rect data-value="6" fill="rgba(0, 77, 235, 0.3)" x="31" y="16.66666666666667" width="8"-->
            <!--                                  height="33.33333333333333"/>-->
            <!--                            <rect data-value="5" fill="rgb(0, 77, 235)" x="40.99999999999999" y="22.22222222222222"-->
            <!--                                  width="8.000000000000014"-->
            <!--                                  height="27.77777777777778"/>-->
            <!--                            <rect data-value="2" fill="rgba(0, 77, 235, 0.3)" x="50.99999999999999"-->
            <!--                                  y="38.888888888888886"-->
            <!--                                  width="8.000000000000007"-->
            <!--                                  height="11.111111111111114"/>-->
            <!--                            <rect data-value="4" fill="rgb(0, 77, 235)" x="61" y="27.77777777777778" width="8"-->
            <!--                                  height="22.22222222222222"/>-->
            <!--                            <rect data-value="3" fill="rgba(0, 77, 235, 0.3)" x="71" y="33.333333333333336" width="8"-->
            <!--                                  height="16.666666666666664"/>-->
            <!--                            <rect data-value="7" fill="rgb(0, 77, 235)" x="81" y="11.111111111111107" width="8"-->
            <!--                                  height="38.88888888888889"/>-->
            <!--                            <rect data-value="5" fill="rgba(0, 77, 235, 0.3)" x="91" y="22.22222222222222" width="8"-->
            <!--                                  height="27.77777777777778"/>-->
            <!--                        </svg>-->
            <!--                        &lt;!&ndash; svg图 结束 &ndash;&gt;-->
            <!--                        &lt;!&ndash; svg图 结束 &ndash;&gt;-->
            <!--                    </el-card>-->
            <!--                </el-col>-->
            <!--                <el-col :md="6" style="margin-top:15px ;">-->
            <!--                    <el-card shadow="hover" class="showText-green">-->
            <!--                        <p style="color:rgb(16, 183, 89);font-size: 18px;">文章总数</p>-->
            <!--                        <p style="font-weight: 700;">15</p>-->
            <!--                        &lt;!&ndash; svg图 &ndash;&gt;-->
            <!--                        <svg class="peity" height="50" width="100">-->
            <!--                            <rect data-value="2" fill="rgb(16, 183, 89)" x="1" y="38.888888888888886" width="8"-->
            <!--                                  height="11.111111111111114"/>-->
            <!--                            <rect data-value="5" fill="rgba(16, 183, 89, 0.3)" x="11.000000000000002"-->
            <!--                                  y="22.22222222222222"-->
            <!--                                  width="7.999999999999998"-->
            <!--                                  height="27.77777777777778"/>-->
            <!--                            <rect data-value="9" fill="rgb(16, 183, 89)" x="21" y="0" width="8" height="50"/>-->
            <!--                            <rect data-value="6" fill="rgba(16, 183, 89, 0.3)" x="31" y="16.66666666666667" width="8"-->
            <!--                                  height="33.33333333333333"/>-->
            <!--                            <rect data-value="5" fill="rgb(16, 183, 89)" x="40.99999999999999" y="22.22222222222222"-->
            <!--                                  width="8.000000000000014"-->
            <!--                                  height="27.77777777777778"/>-->
            <!--                            <rect data-value="2" fill="rgba(16, 183, 89, 0.3)" x="50.99999999999999"-->
            <!--                                  y="38.888888888888886"-->
            <!--                                  width="8.000000000000007"-->
            <!--                                  height="11.111111111111114"/>-->
            <!--                            <rect data-value="4" fill="rgb(16, 183, 89)" x="61" y="27.77777777777778" width="8"-->
            <!--                                  height="22.22222222222222"/>-->
            <!--                            <rect data-value="3" fill="rgba(16, 183, 89, 0.3)" x="71" y="33.333333333333336" width="8"-->
            <!--                                  height="16.666666666666664"/>-->
            <!--                            <rect data-value="7" fill="rgb(16, 183, 89)" x="81" y="11.111111111111107" width="8"-->
            <!--                                  height="38.88888888888889"/>-->
            <!--                            <rect data-value="5" fill="rgba(16, 183, 89, 0.3)" x="91" y="22.22222222222222" width="8"-->
            <!--                                  height="27.77777777777778"/>-->
            <!--                        </svg>-->
            <!--                        <br>-->
            <!--                        &lt;!&ndash; svg图 结束 &ndash;&gt;-->
            <!--                    </el-card>-->
            <!--                </el-col>-->
            <!--                <el-col :md="6" style="margin-top:15px ;">-->
            <!--                    <el-card shadow="hover" class="showText-red">-->
            <!--                        <p style="color:rgb(238,44,44);font-size: 18px;">留言总数</p>-->
            <!--                        <p style="font-weight: 700;">15</p>-->
            <!--                        &lt;!&ndash; svg图 &ndash;&gt;-->
            <!--                        <svg class="peity" height="50" width="100">-->
            <!--                            <rect data-value="2" fill="rgb(238,44,44)" x="1" y="38.888888888888886" width="8"-->
            <!--                                  height="11.111111111111114"/>-->
            <!--                            <rect data-value="5" fill="rgba(238,44,44, 0.3)" x="11.000000000000002"-->
            <!--                                  y="22.22222222222222" width="7.999999999999998"-->
            <!--                                  height="27.77777777777778"/>-->
            <!--                            <rect data-value="9" fill="rgb(238,44,44)" x="21" y="0" width="8" height="50"/>-->
            <!--                            <rect data-value="6" fill="rgba(238,44,44, 0.3)" x="31" y="16.66666666666667" width="8"-->
            <!--                                  height="33.33333333333333"/>-->
            <!--                            <rect data-value="5" fill="rgb(238,44,44)" x="40.99999999999999" y="22.22222222222222"-->
            <!--                                  width="8.000000000000014"-->
            <!--                                  height="27.77777777777778"/>-->
            <!--                            <rect data-value="2" fill="rgba(238,44,44, 0.3)" x="50.99999999999999"-->
            <!--                                  y="38.888888888888886" width="8.000000000000007"-->
            <!--                                  height="11.111111111111114"/>-->
            <!--                            <rect data-value="4" fill="rgb(238,44,44)" x="61" y="27.77777777777778" width="8"-->
            <!--                                  height="22.22222222222222"/>-->
            <!--                            <rect data-value="3" fill="rgba(238,44,44, 0.3)" x="71" y="33.333333333333336" width="8"-->
            <!--                                  height="16.666666666666664"/>-->
            <!--                            <rect data-value="7" fill="rgb(238,44,44)" x="81" y="11.111111111111107" width="8"-->
            <!--                                  height="38.88888888888889"/>-->
            <!--                            <rect data-value="5" fill="rgba(238,44,44, 0.3)" x="91" y="22.22222222222222" width="8"-->
            <!--                                  height="27.77777777777778"/>-->
            <!--                        </svg>-->
            <!--                        &lt;!&ndash; svg图 结束 &ndash;&gt;-->
            <!--                        <br>-->
            <!--                        &lt;!&ndash; svg图 结束 &ndash;&gt;-->
            <!--                    </el-card>-->
            <!--                </el-col>-->
            <!--            </el-row>-->
        </el-card>
    </div>
</template>

<script>
    export default {
        name: 'home',
        data() {
            return {
                //待修改
                city: "福州",
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    /* 设置导航条 实现过渡动画 */
    .home {
        flex: 1;
        overflow: auto;
        width: 100%;
        border: 0;
    }


    /* 设置鼠标进入现实内容*/
    .showText-blue,
    .showText-green,
    .showText-red {
        font-size: 0px;
        color: #ffffff;
    }

    .showText-blue:hover {
        font-size: 25px;
        color: rgb(0, 77, 235);
    }

    .showText-green:hover {
        font-size: 25px;
        color: rgb(16, 183, 89);
    }

    .showText-red:hover {
        font-size: 25px;
        color: rgb(238, 44, 44);
    }

    p {
        margin-top: 10px;
    }

    /* 修改输入框的弧度 */
    .el-input__inner {
        border-radius: 25px;
    }
</style>
